import { render, staticRenderFns } from "./AlertMessage.vue?vue&type=template&id=3a445730&scoped=true&"
import script from "./AlertMessage.vue?vue&type=script&lang=js&"
export * from "./AlertMessage.vue?vue&type=script&lang=js&"
import style0 from "./AlertMessage.vue?vue&type=style&index=0&id=3a445730&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a445730",
  null
  
)

export default component.exports